// extracted by mini-css-extract-plugin
module.exports = {"promo":"ProfilePromo_promo__55FrR","title":"ProfilePromo_title___mTQW"};